const scrollers = document.querySelectorAll(".service-scrolling-content");
function addAnimation() {
    scrollers.forEach((scroller) => {
        scroller.setAttribute("data-animated", true);
        const scrollerInner = scroller.querySelector(".service-info");
        const scrollerContent = Array.from(scrollerInner.children);
        for (let i = 0; i < 55; i++) {
            scrollerContent.forEach((item) => {
                const duplicatedItem = item.cloneNode(true);
                duplicatedItem.setAttribute("aria-hidden", true);
                scrollerInner.appendChild(duplicatedItem);
            });
        }
    });
}
addAnimation();